import { axiosGet, axiosPost } from '../../../react_axios/Axios';
import {
    getFeatureIntimationTemplateListUrl,
    getFeatureIntimationTemplateByIdUrl,
    saveFeatureIntimationTemplateUrl,
    updateFeatureIntimationTemplateUrl,
    createFeatureIntimationUrl,
    getFeatureIntimationListUrl,
    loadFeatureIntimationRecipientsUrl,
    saveFeatureIntimationRecipientsUrl,
    sendFeatureIntimationUrl,
    getFeatureIntimationExhibitionConfigUrl,
    getFeatureIntimationCampaignRecipientsUrl,
} from '../../../utils/constants';

export const getTemplateList_action = (ExhibitionID, UserID) => async (dispatch) => {
    try {
        const res = await axiosGet(getFeatureIntimationTemplateListUrl, { ExhibitionID, UserID });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getTemplateById_action = (TemplateID) => async (dispatch) => {
    try {
        const res = await axiosGet(getFeatureIntimationTemplateByIdUrl, { TemplateID });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const saveTemplate_action = (data) => async (dispatch) => {
    try {
        const res = await axiosPost(saveFeatureIntimationTemplateUrl, data);
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const updateTemplate_action = (data) => async (dispatch) => {
    try {
        const res = await axiosPost(updateFeatureIntimationTemplateUrl, data);
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const createCampaign_action = (data) => async (dispatch) => {
    try {
        const res = await axiosPost(createFeatureIntimationUrl, data);
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getCampaignList_action = (ExhibitionID, UserID, Status, Subject) => async (dispatch) => {
    try {
        const res = await axiosGet(getFeatureIntimationListUrl, { ExhibitionID, UserID, Status, Subject });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const loadRecipients_action = (data) => async (dispatch) => {
    try {
        const res = await axiosPost(loadFeatureIntimationRecipientsUrl, data);
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const saveRecipients_action = (data) => async (dispatch) => {
    try {
        const res = await axiosPost(saveFeatureIntimationRecipientsUrl, data);
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const sendIntimation_action = (data) => async (dispatch) => {
    try {
        const res = await axiosPost(sendFeatureIntimationUrl, data);
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getExhibitionMailConfig_action = (ExhibitionID) => async (dispatch) => {
    try {
        const res = await axiosGet(getFeatureIntimationExhibitionConfigUrl, { ExhibitionID });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getCampaignRecipients_action = (CampaignID) => async (dispatch) => {
    try {
        const res = await axiosGet(getFeatureIntimationCampaignRecipientsUrl, { CampaignID });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};
